import axios from 'axios';
import type { OnboardingPortalAssociation } from '@bb/automaton';

const getAssocMapByOrgsAndPortalId = async ({
  portalId,
  orgIds,
}: {
  portalId: string;
  orgIds: string[];
}) => {
  const url = `/onboarding-portal/${portalId}/association-map-by-orgs`;

  const { data } = await axios.get<
    Record<string, OnboardingPortalAssociation | undefined>
  >(url, { params: { orgIds } });

  return data;
};

export default getAssocMapByOrgsAndPortalId;
